export default (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
    <rect width="100" height="100" rx="12" fill="#0A4B33" />
    <g transform="translate(15, 25)">
      <path d="M0 8 H70 V16 H0 Z" fill="#00D573" />
      <path d="M27 16 H43 V50 H27 Z" fill="#00D573" />
    </g>
  </svg>
);
